// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2lkT8","colCheckbox":"styles_colCheckbox__2AMMh"};